import React from 'react';
import PageBanner from '../../../layout/PageBanner';
import { Link } from 'react-router-dom';

const ActualidadDetalle = (props) => {

  if(props.location) props.state = props.location.state;

  return (
    <div>
    <PageBanner title="Actualidad" img="banner-actualidad.jpg">
      <Link to="/">Home</Link>
      <Link to="/actualidad">Actualidad</Link>
    </PageBanner>

    <section className="blog-wrapper blog02">
    <div className="container">
  			<div className="row">
  				<div className="col-md-9 col-sm-8">
  					<div className="blog-details-wrapper">
              {props.state.video &&
                <div className="embed-responsive embed-responsive-16by9">
                  <iframe title="video" className="embed-responsive-item" width="847" height="400" src={ props.state.video }>
                  </iframe>
                </div>
              }

  						<div className="blog-image">
                {!props.state.video &&
                    <img src={props.state.image} alt={props.state.title} className="img-responsive"/>
                }
  						</div>
  						<div className="blog-meta">
  							<h2>{props.state.title}</h2>
  						</div>
  						<div className="blog-content">
                <p dangerouslySetInnerHTML={{ __html: props.state.description }}>
                </p>
                {props.state.info &&
                  <a href={props.state.info}>
                    <span style={{backgroundColor:'blue',border:'1px solid blue',marginRight:'1%'}} className="rm-btn el-btn-regular">Más Info</span>
                  </a>
                }
                <Link to="/actualidad">
                  <span className="rm-btn el-btn-regular flacso-verde">Volver</span>
                </Link>
  						</div>
  					</div>
  				</div>
  			</div>
		</div>
    </section>
    </div>
  );
}

export default ActualidadDetalle;
